import { TitleProps } from './interfaces';
import styles from './style/Terms.css';

const Title = (props: TitleProps) => (
  <h1 className={styles.header}>{props.value.toUpperCase()}</h1>
);

export default Title;